<template>
<div class="customer-edit">
  <el-form 
    class="" 
    ref="form" 
    label-width="120px" 
    label-position="left" 
    :model="form"
    :rules="rules"
    size="medium">
    <el-row :gutter="20">
      <el-col :lg="12">
        <el-form-item label="企业ID：" prop="companyid">
          <el-input readonly v-model="form.companyid"></el-input>
        </el-form-item>
      </el-col>
      <el-col :lg="12">
        <el-form-item label="数据来源：" prop="dataFrom">
          <el-input readonly v-model="form.dataFrom"></el-input>
        </el-form-item>
      </el-col>
      <el-col :lg="12">
        <el-form-item label="企业名称：" prop="companyname">
          <el-input v-model="form.companyname"></el-input>
        </el-form-item>
      </el-col>
      <el-col :lg="12">
        <el-form-item label="账号注册时间：" prop="ctime">
          <el-input v-model="form.ctime" readonly ></el-input>
        </el-form-item>
      </el-col>
      <el-col :lg="12">
        <el-form-item label="企业类型：" prop="rolecode">
          <el-select v-model="form.roleCode" value-key="rolescode">
            <el-option
              v-for="item in companyTypeList"
              :key="item.rolescode"
              :value="item.rolescode"
              :label="item.rolesname"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :lg="12">
        <el-form-item label="所属行业：" prop="industryid">
          <el-select v-model="form.industryId" value-key="industryid">
            <el-option
              v-for="item in industryList"
              :key="item.industryid"
              :value="item.industryid"
              :label="item.industryname"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :lg="12">
        <el-form-item label="用户分类：" prop="companytypename">
          <el-select v-model="form.companytypes" multiple value-key="id">
            <el-option
              v-for="item in roleList"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :lg="12">
        <el-form-item label="所属大区：" prop="areacategory">
          <el-select v-model="form.areacategory" value-key="key">
            <el-option
              v-for="item in areaList"
              :key="item.key"
              :value="item.key"
              :label="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :lg="12">
        <el-form-item label="企业账号：" prop="account">
          <el-input readonly v-model="form.account" ></el-input>
        </el-form-item>
      </el-col>
      <el-col :lg="12">
        <el-form-item label="固定电话：" prop="tel">
          <el-input v-model="form.tel"></el-input>
        </el-form-item>
      </el-col>
      <el-col :lg="12">
        <el-form-item label="联系人：" prop="linkman">
          <el-input v-model="form.linkman"></el-input>
        </el-form-item>
      </el-col>
      <el-col :lg="12">
        <el-form-item label="企业规模：" prop="scale">
          <el-select v-model="form.scale" value-key="key">
            <el-option
              v-for="item in scaleList"
              :key="item.key"
              :value="item.key"
              :label="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :lg="12">
        <el-form-item label="联系方式：" prop="handset">
          <el-input v-model="form.handset"></el-input>
        </el-form-item>
      </el-col>
      <el-col :lg="12">
        <el-form-item label="注册资本：" prop="buslicenseregisteredcapital">
          <el-input v-model="form.buslicenseregisteredcapital"></el-input>
        </el-form-item>
      </el-col>
      <el-col :lg="12">
        <el-form-item label="联系人职位：" prop="linkmanpost">
          <el-select v-model="form.linkmanpost" value-key="key">
            <el-option
              v-for="item in postList"
              :key="item.key"
              :value="item.key"
              :label="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :lg="12">
        <el-form-item label="企业所在地：" prop="companyaddress">
          <!-- <el-input v-model="form.companyaddress" readonly @click=""></el-input> -->
          <div class="el-input el-input__inner" @click="openMap">{{form.companyaddress}}</div>
        </el-form-item>
      </el-col>
      <el-col :lg="12">
        <el-form-item label="企业注册地：" prop="companyregisteraddress">
          <el-input v-model="form.companyregisteraddress"></el-input>
        </el-form-item>
      </el-col>
      <el-col :lg="12">
        <el-form-item label="经纬度：" prop="lng">
          <span class="inner-item">经度：{{form.lng}}</span>
          <span class="inner-item">纬度：{{form.lat}}</span>
        </el-form-item>
      </el-col>
      <el-col :lg="12">
        <el-form-item label="企业法人：" prop="legalperson">
          <el-input readonly v-model="form.legalperson"></el-input>
        </el-form-item>
      </el-col>
      <el-col :lg="12">
        <el-form-item label="营业执照编号：" prop="businesslicense">
          <el-input v-model="form.businesslicense"></el-input>
        </el-form-item>
      </el-col>
      <el-col :lg="12">
        <el-form-item label="企业执照：" prop="businesslicenseimgpath">
          <el-upload
            :show-file-list="false"
            :action="uploadURL"
            :on-success="uploadLicense"
            accept="image/*"
            class="uploader"
          >
            <img v-if="form.businesslicenseimgpath" :src="form.businesslicenseimgpath" class="pic">
            <i v-else class="el-icon-plus uploader-icon"></i>
            <i v-if="form.businesslicenseimgpath" class="el-icon-error icon-delete" @click.stop="form.businesslicenseimgpath=''"></i>
          </el-upload>
        </el-form-item>
      </el-col>
      <el-col :lg="12">
        <el-form-item label="企业LOGO：" prop="logo">
          <el-upload
            :show-file-list="false"
            :action="uploadURL"
            :on-success="uploadLogo"
            accept="image/*"
            class="uploader">
            <img v-if="form.logo" :src="form.logo" class="pic">
            <i v-else class="el-icon-plus uploader-icon"></i>
            <i v-if="form.logo" class="el-icon-error icon-delete" @click.stop="form.logo=''"></i>
          </el-upload>
        </el-form-item>
      </el-col>
      <el-col :lg="12">
        <el-form-item label="关联母公司：" prop="parentCompanyName">
          <div class="el-input el-input__inner" @click="showParent">{{form.parentCompanyName}}</div>
        </el-form-item>
      </el-col>
      <el-col :lg="12">
        <el-form-item label="企业成立时间：" prop="establishmenttime">
          <el-date-picker
            v-model="form.establishmenttime"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            readonly
            style="width: 100%"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :lg="12">
        <el-form-item label="年营业额：" prop="yearlyturnover">
          <el-input v-model="form.yearlyturnover" readonly></el-input>
          <span class="unit">万</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item>
      <el-button type="primary" @click="save">提交</el-button>
      <el-button @click="cancel">取消</el-button>
    </el-form-item>
  </el-form>
  <el-dialog
    title="地址选择"
    v-if="isShowMap"
    width="700px"
    center
    :visible.sync="isShowMap"
  >
    <!-- 250527_gaodeMap 我的客户-客户详情-地址所在地 -->
    <gaodeMap  id="map" class="gaode-map" :cantEdit="true" :pickedAddress="pickedAddress"  @gaodemapSubmit="gaodemapSubmit"/>
  </el-dialog>
  <el-dialog
    title="关联母公司"
    width="70%"
    center
    :close-on-click-modal="false"
    :visible.sync="isShowParentCompany"
  >
    <parent-company ref="parentCompany" @onChange="pickParentCompany"></parent-company>
    <div class="dialog-footer" slot="footer" style="text-align: right;">
      <!-- <el-button @click="isShowParentCompany = false">取消</el-button> -->
      <el-button type="primary" @click="confirmParentCompany">确定</el-button>
    </div>
  </el-dialog>
</div>
</template>
<script>
import {
  customerInfoUpdate,
  customerDetail,
  parentCompanyUpdate,
  areaInfoGet,                    //选择完地图之后调用
} from '@/service/customerInformation.js';
import {
  validContact
} from '@/utils/formRule.js';
import apiEnv from '@/service/apiEnv.js'
import ParentCompany from '@/pages/customer/index/parentCompany.vue';
import {
  linkManPost,
  scale,
  areaCategory,
  companyRoles,
  industrys,
  companyTypes,
} from '@/service/area.js';
import gaodeMap from "@/components/gaodeMap.vue";
export default {
  components:{
    ParentCompany,
    gaodeMap
  },
  data(){
    return{
      form:{
        companyid:'',
        dataFrom:'',
        companyname:'',
        ctime:'',
        rolecodename:'',
        roleCode:'',
        industryname:'',
        industryId:'',
        companytypes:[],
        companytypename:'',
        areacategory:'',
        account:'',
        tel:'',
        linkman:'',
        scale:'',
        handset:'',
        buslicenseregisteredcapital:'',
        linkmanpost:'',
        companyaddress:'',
        companyregisteraddress:'',
        lng:'',
        lat:'',
        legalperson:'',
        businesslicense:'',
        businesslicenseimgpath:'',
        logo:'',
        parentCompanyName:'',
        parentCompanyId:0,
        establishmenttime:'',
        yearlyturnover:'',

        provinceId: '',
        cityId: '',
      },
      uploadURL:apiEnv.uploadURL,
      isShowMap:false,
      isShowParentCompany:false,
      postList:[],//职位列表
      areaList:[],//所属大区
      companyTypeList:[],//企业类型列表
      industryList:[],//行业列表
      roleList:[],//用户分类列表
      scaleList:[],//企业规模
      rules:{
        companytype:[{required: true, message: '请选择用户分类', trigger: 'change'}],
        linkman:[{required: true, message: '请输入联系人', trigger: 'blur'}],
        handset:[{required: true, message: '请输入联系方式', trigger: 'blur'},{validator:validContact, trigger: 'blur'}],
        companyaddress:[{required: true, message: '请输入企业所在地', trigger: 'blur'}],
        businesslicense:[{required: true, message: '请输入营业执照', trigger: 'blur'}],
        businesslicenseimgpath:[{required: true, message: '请上传企业营业执照', trigger: 'change'}],
      },
      parentCompany:null,//母公司
      pickedAddress: {}
    }
  },
  mounted() {
    this.pageInit();
    this.receiveData();
  },
  methods: {
    //获取数据
    pageInit(){
      //获取职位列表
      linkManPost().then(r=>{
        if(r.Result==1){
          this.postList=r.Data ||[];
        }
      })
      //用户分类列表
      companyTypes().then(r=>{
        if(r.Result==1){
          this.roleList=r.Data ||[];
        }
      })
      //获取行业列表
      industrys({
        lvl:'1'
      }).then(r=>{
        if(r.Result==1){
          this.industryList=r.Data ||[];
        }
      })
      //获取大区列表
      areaCategory().then(r=>{
        if(r.Result==1){
          this.areaList=r.Data ||[];
        }
      })
      //获取企业类型列表
      companyRoles().then(r=>{
        if(r.Result==1){
          this.companyTypeList=r.Data ||[];
        }
      })
      //获取企业规模列表
      scale().then(r=>{
        if(r.Result==1){
          this.scaleList=r.Data ||[];
        }
      })
      let custId=Number(this.$route.query.custId);
      customerDetail({
        custId:custId,
      }).then(r=>{
        if(r.Result==1){
          let data=r.Data || {};
          for (const k in this.form) {
            if (Object.hasOwnProperty.call(data, k)) {
              this.form[k]=data[k];
            }
          }
          this.form.industryId = !data.industryId?'':data.industryId
          this.form.areacategory = !data.areacategory?'':data.areacategory
          this.form.scale = !data.scale?'':data.scale
          this.form.linkmanpost=data.linkmanpost||'';
          this.form.roleCode=Number(data.roleCode);
          this.form.companytypes=data.companyTypes;
        }
      })
    },
    //上传营业执照
    uploadLicense(res){
      if(res.Result==1){
        this.form.businesslicenseimgpath=res.Data[0].imgUrl;
      }
    },
    //上传logo
    uploadLogo(res){
      if(res.Result==1){
        this.form.logo=res.Data[0].imgUrl;
      }
    },
    openMap() {
      this.isShowMap=true;
      setTimeout(() => {
        this.pickedAddress = {
          FullAddress: this.form.companyaddress,
          Lng: this.form.lng,
          Lat: this.form.lat
        }
      }, 500);
    },
    gaodemapSubmit(params) {
      console.log("gaodemapSubmit", params)
      this.isShowMap = false;
      if(params.Lat) {
        this.form.companyaddress=params.FullAddress;
        this.form.lng=params.Lng;
        this.form.lat=params.Lat;
      }
    },
    //接受iframe传出来的信息
    // receiveData(){
    //   let that=this;
    //   window.addEventListener('message',function(e) {
    //     let data={};
    //     let value=e.data;
    //     if(that.isJsonString(value)){
    //       data=JSON.parse(value);
    //     }
    //     if(data.Lat){
    //       that.form.companyaddress=data.FullAddress;
    //       that.form.lng=data.Lng;
    //       that.form.lat=data.Lat;
    //       areaInfoGet({'cityName':data.CityName}).then(res=> {
    //         if(res.Result != 1) {
    //           return this.$message.info(res.Message);
    //         }
    //         that.form.provinceId = res.Data.provinceId
    //         that.form.cityId = res.Data.cityId
    //       })
    //     }
    //     that.isShowMap=false;
        
    //   })
    // },
    isJsonString(str) {
        try {
            if (typeof JSON.parse(str) == "object") {
                return true;
            }
        } catch(e) {
          return false;
        }
        return false;
    },
    showParent(){
      this.isShowParentCompany=true;
      this.parentCompany=null;
      if(this.$refs.parentCompany){
        this.$refs.parentCompany.loadList();
      }
    },
    //选择关联母公司
    pickParentCompany(data){
      this.parentCompany=data;
    },
    //确认关联母公司
    confirmParentCompany(){
      if(!this.parentCompany){
        this.$message.info('请选择母公司');
        return;
      }
      let companyId=Number(this.$route.query.companyId);
      let data = {
        companyId: companyId,
        parentCompanyId: this.parentCompany.companyid
      }
      parentCompanyUpdate(data).then(res=> {
        if(res.Result != 1) {
          return  this.$message.info(res.Message);
        }
        this.form.parentCompanyName=this.parentCompany.companyname;
        this.form.parentCompanyId=this.parentCompany.companyid;
        this.isShowParentCompany=false;
      })
      
    },
    //保存
    save(){
      let custId=Number(this.$route.query.custId);
      this.$refs.form.validate((valid=>{
        if(valid){
          let params={
            ...this.form,
            registeraddress: this.form.companyregisteraddress,
            custId: custId
          }
          delete params.companyregisteraddress
          params['industry'] = params.industryId
          params['fulladdress'] = params.companyaddress
          delete params.companyaddress
          delete params.industryId
          customerInfoUpdate(params).then(r=>{
            if(r.Result==1){
              this.$message.success('编辑成功');
              this.$emit('onChange',false);
            }else{
              this.$message.info(r.Message);
            }
          })
          
        }
      }))
    },
    cancel(){
      this.$emit('onChange',false);
    },
  },
}
</script>
<style lang="scss">
.customer-edit{
  .el-select{
    width: 100%;
  }
  .el-upload{
    width: 120px;
    height: 120px;
    position: relative;
  }
  .el-input.el-input__inner{
    height: 36px;
    line-height: 36px;
  }
  .uploader-icon{
    display: block;
    width: 120px;
    height: 120px;
    border: 1px solid #e5e5e5;
    line-height: 120px;
    font-size: 40px;
    color: #e5e5e5;
    border-radius: 4px;
  }
  .icon-delete{
    position: absolute;
    right: 0;
    top: 2px;
    font-size: 16px;
    color: #f75959;
  }
  .pic{
    display: block;
    width: 120px;
    height: 120px;
    border-radius: 4px;
  }
  .el-input input:read-only{
    background-color: #f5f5f5;
  }
  .el-select .el-input input:read-only{
    background-color: #fff;
  }
  .unit{
    position: absolute;
    right: 10px;
    top: 0;
    font-size: 14px;
    color: #666;
    line-height: inherit;
  }
  .inner-item{
    display: inline-block;
    white-space: nowrap;
    font-size: 14px;
    color: #333;
    &+.inner-item{
      margin-left: 10px;
    }
  }
}
</style>
<style lang="scss" scoped>
  .gaode-map {
      height: 500px;
      position: relative;
  }
</style>